import { Insurance, InsurancePaymentType } from '@features/product/typings';

export default function hasMonthlyInsurances(insurance: Insurance): boolean {
  return insurance.packages.some(insurancePackage =>
    insurancePackage.products.some(product => product.paymentType === InsurancePaymentType.MONTHLY)
  );
}
